<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="ការទូទាត់ការដាក់ប្រាក់" name="first"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ការដកប្រាក់" name="second"></el-tab-pane>
			<!-- <el-tab-pane label="ការទូទាត់ប្រាក់អ្នកដឹកជញ្ជូន" name="third" v-if="$store.state.authentication.account_type != 'ca'"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់អ្នកទៅទទួលកញ្ចប់ឥវ៉ាន់" name="forth" v-if="$store.state.authentication.account_type != 'ca'"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់អ្នកទីផ្សារ" name="fifth" v-if="$store.state.authentication.account_type != 'ca'"></el-tab-pane> -->
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<md-card v-for="(payment, index) in depositList">
				<md-card-header data-background-color="orange">
					<h4 class="title">{{index+1}}. <b>{{payment.payment_type}}</b></h4>
				</md-card-header>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-table>
								<md-table-row>
									<!-- <md-table-head>ល.រ</md-table-head> -->
									<md-table-head>លេខកូដ</md-table-head>
									<md-table-head>អតិថិជន</md-table-head>
									<md-table-head>អតិថិជន</md-table-head>
									<md-table-head>ចំនួន</md-table-head>
									<md-table-head>អ្នកអនុម័ត</md-table-head>
									<md-table-head>កំណត់ចំណាំ</md-table-head>
								</md-table-row>

								<md-table-row v-for="(deposit, index) in payment.depositList">
									<!-- <md-table-cell></md-table-cell> -->
									<md-table-cell>​{{ index + 1 }}, <b>{{ deposit.id}}</b><br>{{config.datelify(deposit.created_date)}}</md-table-cell>
									<md-table-cell><b>{{ deposit.username }}</b><br>{{deposit.name}}</md-table-cell>
									<md-table-cell><b>{{ deposit.name }}</b><br>{{deposit.phone}}</md-table-cell>
									<md-table-cell><b>{{ config.moneylify(deposit.amount) }}</b></md-table-cell>
									<md-table-cell><b>{{ deposit.approve_by }}</b><br>{{config.datelify(deposit.approved_date)}}</md-table-cell>
									<md-table-cell><span v-if="deposit.note_admin != null">{{ deposit.note_admin }}</span><span v-else>មិនមាន</span></md-table-cell>
								</md-table-row>
							</md-table>

						</div>
						<div class="md-layout-item md-size-80 text-right"
							style="display: flex;justify-content: right; align-items: center;">
							<b><span>ទឹកប្រាក់ត្រូវទូទាត់នឹង CS: {{config.moneylify(payment.total)}}</span></b>
						</div>
						<!-- <div class="md-layout-item md-size-20 text-right">
							<a :href="'#/print_payment/' + client.client_hash_id" target="_blank">
								<md-button class="md-raised md-primary" style="width:100%">បោះពុម្ភ</md-button>
							</a>
						</div> -->
						<div class="md-layout-item md-size-20 text-right"v-if="$store.state.authentication.account_type == 'sa'">
							<md-button class="md-raised md-primary" style="width:100%" @click="showDeposit(payment)">
								ទូទាត់</md-button>
						</div>

					</div>
				</md-card-content>
			</md-card>

			<h4 class="text-center" v-if="depositList.length == 0 && loadMore == true">មិនមានទិន្នន័យ</h4>
		</div>

		<div v-if="tabName == 'second'">
			<md-card v-for="(payment, index) in withdrawList">
				<md-card-header data-background-color="orange">
					<h4 class="title">{{index+1}}. <b>{{payment.payment_type}}</b></h4>
				</md-card-header>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-table>
								<md-table-row>
									<!-- <md-table-head>ល.រ</md-table-head> -->
									<md-table-head>លេខកូដ</md-table-head>
									<md-table-head>អតិថិជន</md-table-head>
									<md-table-head>អតិថិជន</md-table-head>
									<md-table-head>ចំនួន</md-table-head>
									<md-table-head>អ្នកអនុម័ត</md-table-head>
									<md-table-head>កំណត់ចំណាំ</md-table-head>
								</md-table-row>

								<md-table-row v-for="(withdraw, index) in payment.withdrawList">
									<!-- <md-table-cell></md-table-cell> -->
									<md-table-cell>​{{ index + 1 }}, <b>{{ withdraw.id}}</b><br>{{config.datelify(withdraw.created_date)}}</md-table-cell>
									<md-table-cell><b>{{ withdraw.username }}</b><br>{{withdraw.name}}</md-table-cell>
									<md-table-cell><b>{{ withdraw.name }}</b><br>{{withdraw.phone}}</md-table-cell>
									<md-table-cell><b>{{ config.moneylify(withdraw.amount) }}</b></md-table-cell>
									<md-table-cell><b>{{ withdraw.approve_by }}</b><br>{{config.datelify(withdraw.approved_date)}}</md-table-cell>
									<md-table-cell><span v-if="withdraw.note_admin != null">{{ withdraw.note_admin }}</span><span v-else>មិនមាន</span></md-table-cell>
								</md-table-row>
							</md-table>

						</div>
						<div class="md-layout-item md-size-80 text-right"
							style="display: flex;justify-content: right; align-items: center;">
							<b><span>ទឹកប្រាក់ត្រូវទូទាត់នឹង CS: {{config.moneylify(payment.total)}}</span></b>
						</div>
						<!-- <div class="md-layout-item md-size-20 text-right">
							<a :href="'#/print_payment/' + client.client_hash_id" target="_blank">
								<md-button class="md-raised md-primary" style="width:100%">បោះពុម្ភ</md-button>
							</a>
						</div> -->
						<div class="md-layout-item md-size-20 text-right" v-if="$store.state.authentication.account_type == 'sa'">
							<md-button class="md-raised md-primary" style="width:100%" @click="showWithdraw(payment)">
								ទូទាត់</md-button>
						</div>

					</div>
				</md-card-content>
			</md-card>

			<h4 class="text-center" v-if="withdrawList.length == 0 && loadMore == true">មិនមានទិន្នន័យ</h4>
		</div>

		<md-dialog-confirm :md-active.sync="clearDepositDialogActive" md-title="តើអ្នកពិតជាចង់ទូទាត់ការដាក់ប្រាក់មែនទេ ?"
			md-confirm-text="ទូទាត់" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="clearDeposit" />
			<md-dialog-confirm :md-active.sync="clearWithdrawDialogActive" md-title="តើអ្នកពិតជាចង់ទូទាត់ការដកប្រាក់មែនទេ ?"
			md-confirm-text="ទូទាត់" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="clearWithdraw" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getPaymentDeposit();
			this.getPaymentWithdraw();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				clearDepositDialogActive: false,
				clearDepositSelected: null,
				clearWithdrawDialogActive: false,
				clearWithdrawSelected: null,
				total_deposit: 0,
				total_withdraw: 0,
				loadMore: true,
				depositList: [],
				withdrawList: []
			}
		},
		methods: {
			getPaymentDeposit() {
				this.$http.get(this.config.api + "/admin/deposit/get_payment").then(data => {
					if (data.body.status == 'success') {
						this.depositList = data.body.data
						this.loaded = true;
					}
				})
			},
			getPaymentWithdraw() {
				this.$http.get(this.config.api + "/admin/withdraw/get_payment", {
					text: ""
				}).then(data => {
					if (data.body.status == 'success') {
						this.withdrawList = data.body.data
						this.loaded = true;
					}
				})
			},
			clearDeposit() {
				this.$http.post(this.config.api + "/admin/deposit/clear_payment", {
					payment: this.clearDepositSelected
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ទូទាត់ប្រាក់បានជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.getPaymentDeposit();
					}
				})
			},
			clearWithdraw() {
				this.$http.post(this.config.api + "/admin/withdraw/clear_payment", {
					payment: this.clearWithdrawSelected
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ទូទាត់ប្រាក់បានជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.getPaymentWithdraw();
					}
				})
			},
			showDeposit(deposit) {
				this.clearDepositSelected = deposit;
				this.clearDepositDialogActive = true;
			},
			showWithdraw(withdraw) {
				this.clearWithdrawSelected = withdraw;
				this.clearWithdrawDialogActive = true;
			},
			onCancel() {
				this.clearDepositSelected = null;
				this.clearDepositDialogActive = false;
				this.clearWithdrawSelected = null;
				this.clearWithdrawDialogActive = false;
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Payments/View.vue